import { Card, styled } from "@mui/material";

export const StyledCard = styled(Card)(
  ({ theme: { palette, spacing, breakpoints } }) => ({
    background: palette.custom.teal[50],
    marginTop: spacing(2),
    padding: spacing(4),
    border: "none",

    [breakpoints.down("md")]: {
      paddingTop: spacing(3),
      paddingBottom: spacing(3),
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
    },
  }),
);
